var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqRgn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_25352)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2.5,
    stroke: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 2.5,
    stroke: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82929 15C7.69759 14.6274 7.49436 14.2885 7.23611 14H8.76389C8.50564 14.2885 8.30241 14.6274 8.17071 15H7.82929ZM13.8293 15C13.6976 14.6274 13.4944 14.2885 13.2361 14H16.0858C16.4836 14 16.8651 14.158 17.1464 14.4393L20.5607 17.8536C20.6544 17.9473 20.7816 18 20.9142 18H24C24.2761 18 24.5 18.2239 24.5 18.5C24.5 18.7761 24.2761 19 24 19H20.9142C20.5164 19 20.1349 18.842 19.8536 18.5607L16.4393 15.1464C16.3456 15.0527 16.2184 15 16.0858 15H13.8293ZM2.17071 15C2.30241 14.6274 2.50564 14.2885 2.76389 14H1.5C0.947715 14 0.5 14.4477 0.5 15V16C0.5 16.2761 0.723858 16.5 1 16.5C1.27614 16.5 1.5 16.2761 1.5 16V15H2.17071Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5V12.5C1 11.9477 1.44772 11.5 2 11.5L16.5858 11.5C16.851 11.5 17.1054 11.6054 17.2929 11.7929L24 18.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_25352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqRgn);
export default __webpack_public_path__ + "static/media/eq-RGN.1ef63115f5af6a8cdc067caad3e367f9.svg";
export { ForwardRef as ReactComponent };